import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import Technology from '../components/Technology';
import Products from '../components/Products';
import DashboardPreview from '../components/DashboardPreview';
import DocsYouTube from '../components/DocsYouTube';
interface HomeProps {
    connectionCount?: number;
}

const Home: React.FC<HomeProps> = ({ connectionCount }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/overview');
        }
    }, [navigate]);

    return (
        <>
            <Hero connectionCount={connectionCount} />
            <Technology />
            <Products />
            <DashboardPreview />
            <DocsYouTube />
        </>
    );
};

export default Home;
